import React, { Component } from 'react';
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
// Requests
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig';
import Waiting from '../../../waiting';
// Images
import Logo from './../../../../../statics/img/contact/logo.png';
import BackIcon from './../../../../../statics/img/contact/back.svg';
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import Status from '../../components/IframeStatus/Status';
import {decode as base64_decode} from 'base-64';
import jwt_decode from "jwt-decode";
import OtpInput from 'react-otp-input';
import './Contact.css';

let resend_setInterval; 
let change_installment_setInterval; 

const englishTextLocale = {
back:"Back",
enterNationalID:"Please Enter your National ID",
next:"Next",
purchaseAmount:"Your purchase amount is",
egp:"EGP",
down_payment:"Down payment",
enterValidNumber:"Please enter a valid number.",
select_plan:"Select installment plan",
months:"months",
proceed:"Proceed",
verification:"Verification",
verification_please_enter:"Verification Please enter the 4-digit code sent to",
please_enter_valid_national_id:"Please enter a valid National ID number.",
field_is_required:"This field is required.",
please_enter_valid_pin_code:"Please enter a valid pin code.",
validOTP:"Please Enter a valid OTP",
confirm:"Confirm",
};
const arabicTextLocale = {
back:"عودة",
enterNationalID:"الرجاء إدخال الرقم القومي",
next:"التالي",
purchaseAmount:" مبلغ الشراء",
egp:"جنيه",
down_payment:"المبلغ المقدم",
enterValidNumber:"الرجاء إدخال رقم صحيح.",
select_plan:"اختر خطة التقسيط",
months:"شهر",
proceed:"التالي",
verification:"التحقق",
verification_please_enter:"الرجاء إدخال الرمز المكون من 4 أرقام المرسل إلى",
please_enter_valid_national_id:"الرجاء إدخال رقم بطاقة الهوية الوطنية الصحيح.",
field_is_required:"هذا الحقل مطلوب.",
please_enter_valid_pin_code:"الرجاء إدخال رمز PIN صحيح.",
validOTP:"الرجاء إدخال رمز مرور صحيح",
confirm:"تأكيد",
};
class Contact extends Component {

    constructor(props) {
        super(props)
        this.state = {
            //Public
            step: 1,
            waiting: false,
            error: false,
            error_message: "",
            public_error: false,
            public_error_message: "",
            // Step 1
            national_id: "",
            pin_code: "",
            // Step 2
            trnx_id: "",
            reference: "",
            installment_plans: [],
            selected_plan: {},
            selected_plan_index: "",
            change_installment_waiting: false,
            change_installment_counter: 2,
            down_payment: 0,
            down_payment_error: false,
            financed_amout: 0,
            fees: 0,
            monthly_paid: 0,
            loan_amount: 0,
            total_amount: 0,
            admin_fees: 0,
            cash_amount: 0,
            agree: false,
            step_2_validations: [true, false, false],
            submit_step_2: false,
            // Step 3
            otp: "",
            otp_error: false,
            otp_error_message: "",
            resend: false,
            resend_counter: 30,
            resend_otp_times: 0,
            invalid_otp_times: 1,
            submit_step_4: false,
            // Status Screen
            status: null,
            status_message: "",
            redirection_url: "",
            // User Data
            user_data: "",
            lang:"en"
            //localeData
            ,localeText:englishTextLocale
        };
    }
    componentDidMount(){
        this.decodePaymentToken();
    }

    // Start Logic ..........................................................................

    // Step 1
    
    // decode payment token
    decodePaymentToken = () => {
        // decode from base64 format
        let base64 = base64_decode(this.props.payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        this.setState({user_data: jwt}, ()=>{
            this.setState({financed_amout: (this.state.user_data.amount_cents / 100) - this.state.down_payment})
        });
    }

    // Handle Back Button
    handleBack = () => {
        this.setState({step: this.state.step - 1, error: false, error_message :""});
    }
    changeLanguage = () => {
        if(this.state.lang === "en"){
            this.setState({lang:"ar", localeText:arabicTextLocale})
        }
        else{
            this.setState({lang:"en"})
        }
    }
    // Validations
    requiredV = (value) => {
        if(validator.isEmpty(value)){
            return(
                // We can return string or jsx as the 'error' prop for the validated Component
                <div className="alert alert-danger" role="alert">
                    {this.state.localeText.field_is_required}
                </div>
            )
        }
    };
    nationalIDV = (value,props) => {
        if(props.isChanged === true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length !== 14){
                    return <div className="alert alert-danger" role="alert">{this.state.localeText.please_enter_valid_national_id}</div>;
                }
            }
        }
    };
    pinCodeV = (value,props) => {
        if(props.isChanged === true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length !== 5){
                    return <div className="alert alert-danger" role="alert">{this.state.localeText.please_enter_valid_pin_code}</div>;
                }
            }
        }
    };

    // Step 2

    // Down payment change
    handle_down_payment_change = (value) => {
        clearInterval(change_installment_setInterval);
        this.setState({down_payment:value,loading: true}, () => {
            if(value === ""){
                let new_state = {...this.state}
                new_state.down_payment_error = false;
                new_state.step_2_validations[0] = true;
                this.setState(new_state, ()=> {
                    this.check_step_2_validation()
                    //this.handle_financed_amount_change();
                    //this.handle_cash_amount_change();
                    this.start_change_installment_counter();
                    this.calculate_installment();
                });
            }else{
                if(!validator.isNumeric(value) || value > this.state.user_data.amount_cents / 100){
                    let new_state = {...this.state}
                    new_state.down_payment_error = true;
                    new_state.step_2_validations[0] = false;
                    this.setState(new_state, ()=> this.check_step_2_validation());
                }else{
                    let new_state = {...this.state}
                    new_state.down_payment_error = false;
                    new_state.step_2_validations[0] = true;
                    this.setState(new_state, ()=> {
                        this.check_step_2_validation()
                        //this.handle_financed_amount_change();
                        //this.handle_cash_amount_change();
                        this.start_change_installment_counter();
                        this.calculate_installment();
                    });
                }
            }
        });
    }
    // Handle select plan
    handle_select_plan = (plan, index) => {
        let new_state = {...this.state}
        new_state.selected_plan = plan;
        new_state.selected_plan_index = index;
        new_state.tenor = plan.tenor;
        new_state.step_2_validations[1] = true;
        console.log(plan);
        this.setState(new_state, ()=> {
            this.check_step_2_validation();
            this.handle_cash_amount_change();
            this.calculate_installment();
        });
    }
    // Change Installment Counter 
    start_change_installment_counter = () => {
        clearInterval(change_installment_setInterval);
        change_installment_setInterval = setInterval(this.change_installment_calc, 3000);
    }
    change_installment_calc = () => {
        if(this.state.change_installment_counter > 0){
            this.setState({change_installment_counter: this.state.change_installment_counter - 1});
        }else{
            clearInterval(change_installment_setInterval);
            this.setState({change_installment_counter: 2}, () => {
                // Change installment plans
               // this.change_installment_plans();
            });
        }
    }
    // Financed amount change
    handle_financed_amount_change = () => {
        this.setState({financed_amout: (this.state.user_data.amount_cents / 100) - Number(this.state.down_payment)});
    }
    // Cash amount change
    handle_cash_amount_change = () => {
        this.setState({cash_amount: Number(this.state.down_payment) + this.state.admin_fees});
    }
    handle_agreement_change = () => {
        let new_state = {...this.state};
        new_state.agree = !this.state.agree;
        new_state.step_2_validations[2] = !this.state.agree;
        this.setState(new_state, ()=> this.check_step_2_validation());
    }
    // Check Step 2 validations
    check_step_2_validation = () => {
        if (this.state.step_2_validations[0] === true && this.state.step_2_validations[1] === true  === true){
            this.setState({submit_step_2: true});
        }else{
            this.setState({submit_step_2: false});
        }
    }

    // Step 4

    // OTP Validation
    handle_otp_change = (value) => {
        this.setState({otp: value, error: false, error_message: ""}, () => {
            if(this.state.otp === ""){
                this.setState({otp_error: true, otp_error_message: this.state.localeText.field_is_required, submit_step_4: false});
            }else if(this.state.otp.length !== 4){
                this.setState({otp_error: true, otp_error_message: this.state.localeText.validOTP, submit_step_4: false});
            }else{
                this.setState({otp_error: false, otp_error_message: "", submit_step_4: true});
            } 
        });
    }
    // handle Resend OTP
    handleResendOtp = () => {
        this.setState({resend_otp_times: this.state.resend_otp_times + 1}, () => {
            if(this.state.resend_otp_times === 4){
                this.cancelTrnx();
            }else{
                this.resendOtp();
            }
        });
    }
    // Resend OTP Counter 
    start_resend_counter = () => {
        this.setState({resend: true});
        clearInterval(resend_setInterval);
        resend_setInterval = setInterval(()=>this.resend_counter_calc(), 1000)
    }
    resend_counter_calc = () => {
        if(this.state.resend_counter > 0){
            this.setState({resend_counter: this.state.resend_counter - 1});
        }else{
            clearInterval(resend_setInterval);
            this.setState({resend_counter: 30, resend: false});
        }
    }

    // End Logic .........................................................................

    // Start Requests ....................................................................

    // 1st Request >> Check Data
    check_data = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/contact/contact-plans';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "national_id": this.state.national_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                console.log(resp.data);
                this.setState({installment_plans: resp.data.tenors, step:2,waiting: false, error: false, error_message: ""}, () => {
                   // this.load_installment_plans();
               });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    if(err.response.data.message ==="Customer account is deactivated or suspended." && this.state.lang ==="ar"){
                        this.setState({waiting: false, error: true, error_message:"حساب العميل معطل أو مغلق"});
                    }
                    else{
                        this.setState({waiting: false, error: true, error_message: err.response.data.message});
                    }
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong"});
                }
            });
        });
    }
    // 2nd Request >> Load Installment Plans (Pay)
    calculate_installment = () => {
        this.setState({change_installment_waiting: true},()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/contact/calculate-installment';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "national_id": this.state.national_id,
                "down_payment": this.state.down_payment*100,
                "tenor":this.state.selected_plan.tenor,
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({change_installment_waiting: false,waiting: false, error: false, error_message: "", monthly_paid : resp.data.monthly_paid,
                loan_amount :resp.data.loan_amount,
                total_amount : resp.data.total_amount,
                fees : resp.data.fees});
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({change_installment_waiting: false,waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({change_installment_waiting: false,waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        })

    }

    // 4th Request >> Installment Plan Review
    installment_plan_review = (e) => {
        e.preventDefault();
        this.setState({waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source":{
                    "identifier": this.state.national_id,
                    "subtype": "CONTACT"
                },
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: "", step: 3, trnx_id: resp.data.id, mobile_number: resp.data.data.mobile_number}, () => {});
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }

    // 6th Request >> Confirm Trnx (Confirm OTP)
    confirmTrnx = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/contact/verify-otp';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction": this.state.trnx_id,
                "otp": this.state.otp,
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(resp.data.success === true && resp.data.pending === false){
                    this.setState({waiting: false, error: false, error_message: "", status: "success", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === false && resp.data.pending === true){
                    // pending
                    this.setState({waiting: false, error: false, error_message: resp.data.message||"", status: "pending", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === false && resp.data.pending === false){
                    // fail
                    this.setState({waiting: false, error: false, error_message: "", status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
            })
            .catch((err)=>{
                // Max Trials for Invalid OTP
                if(this.state.invalid_otp_times !== 3){
                    if(err.response.data && err.response.data.message){
                        this.setState({waiting:false, error: true, error_message: err.response.data.message});
                    }else{
                        this.setState({waiting:false, error: true, error_message: "Something went wrong please try again."});
                    }
                }else{
                    this.cancelTrnx();
                }
                // Increase Trials for Invalid OTP
                this.setState({invalid_otp_times: this.state.invalid_otp_times + 1});
            }); 
        });
    }
    // 7th Request >> Resend OTP
    resendOtp = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source":{
                    "identifier": this.state.national_id,
                    "subtype": "CONTACT"
                },
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: ""}, () => {
                    this.start_resend_counter();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    // 8th Request >> Cancel Trnx
    cancelTrnx = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/cancel/transaction_decline';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "message": "Canceled By User",
                "response_code": "-1",
                "transaction_id": this.state.trnx_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // fail
                this.setState({waiting: false, public_error: false, public_error_message: "", status: "fail", redirection_url: resp.data.redirection_url});
            })
            .catch((err)=>{
                if(err && err.response && err.response.data && err.response.data.error){
                    this.setState({waiting: false, public_error: true, public_error_message: err.response.data.error});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong! please try again."});
                }
            });
        });
    }

    // End Requests ......................................................................

    // Start UI ..........................................................................

    renderStep1 = () => (
        <div className="contact_iframe_content">
            <VForm onSubmit={()=>this.check_data()}>
                {this.state.lang === "en"? <label>{`Your purchase amount is ${this.state.user_data.amount_cents/100} LE`}</label>: <label>{`مبلغ الشراء ${this.state.user_data.amount_cents/100} جنيه`}</label>}
              
                <div className="iframe_input">
                    <label>{this.state.localeText.enterNationalID}</label>
                    <VInput 
                        type="text"
                        name="phone_number"
                        id="phone_number"
                        maxLength="14"
                        value={this.state.national_id}
                        onChange={(e)=>this.setState({national_id: e.target.value})}
                        validations={[this.requiredV, this.nationalIDV]} 
                        style={{textAlign:"center"}}
                    />
                </div>
                {this.state.error &&
                    <div className="iframe_error">
                        {this.state.error_message}
                    </div>
                }
                <VButton>{this.state.localeText.next}</VButton>
            </VForm>
        </div>
    )
    renderStep2 = () => (
        <div className="contact_iframe_content" dir={this.state.lang ==="ar"?"rtl":"ltr"}>
            {/* hide down-payment for IKEA user id and waffarha user id  and Vodafone user_id*/}
            {(this.state.user_data && this.state.user_data.user_id && (this.state.user_data.user_id === 391940 || this.state.user_data.user_id === 6824 || this.state.user_data.user_id === 955739) ) ?
                null
            :
                <div className="iframe_input">
                    <label>{this.state.localeText.down_payment}</label>
                    <input 
                        type="text"
                        name="down_payment"
                        id="down_payment"
                        value={this.state.down_payment}
                        onChange={(e)=>this.handle_down_payment_change(e.target.value)}
                    />
                    {this.state.down_payment_error && 
                        <div className="alert alert-danger" role="alert">
                            {this.state.localeText.enterValidNumber}
                        </div>
                    }
                </div>
            }
            <div className="installment_plans_container">
                <label>{this.state.localeText.select_plan}</label>
                {this.state.change_installment_waiting ?
                    <Waiting height='200px' />
                :
                    <div className="installment_plans">
                        {this.state.installment_plans.map((plan, index) => (
                            <div key={index} onClick={()=>this.handle_select_plan(plan, index)} className={`${this.state.selected_plan_index === index ? "selected" : ""}`} style={{float:this.state.lang==="en"?"left !important":"right"}}>
                                <label>
                                    <span className="circle"><span></span></span>
                                    <p>{plan.tenor} {this.state.localeText.months}</p>
                                </label>
                            </div>
                        ))}
                    </div>
                }
            </div>
            {this.state.lang ==="en"?       <div className="summary">
                <h4>Payment summary</h4>
                <p className="contact_summary_field" id="total_amount">Total amount <span>{this.state.user_data.currency} {this.state.total_amount}</span></p>
                <hr />
                <p className="contact_summary_field" id="down_payment">Down payment <span>{this.state.user_data.currency} {this.state.down_payment}</span></p>
                <hr />
                <p className="contact_summary_field" id="financed_amount">Loan amount <span>{this.state.user_data.currency} {this.state.loan_amount}</span></p>
                <hr />
                <p className="contact_summary_field" id="monthly_paid">Monthly paid <span>{this.state.user_data.currency} {this.state.monthly_paid}</span></p>
                <hr />
                <p className="contact_summary_field" id="admin_fees">Admin fees <span>{this.state.user_data.currency} {this.state.fees}</span></p>
            </div>:<div className="summary"dir="rtl">
                <h4>تفاصيل العملية</h4>
                <p className="contact_summary_field" id="total_amount"><span>المبلغ الكلي</span>{this.state.total_amount} {this.state.user_data.currency ==="EGP"?"جنيه":this.state.user_data.currency }</p>
                <hr />
                <p className="contact_summary_field" id="down_payment"><span>المبلغ المقدم</span>{this.state.down_payment} {this.state.user_data.currency ==="EGP"?"جنيه":this.state.user_data.currency }</p>
                <hr />
                <p className="contact_summary_field" id="financed_amount"><span>مبلغ التقسيط</span>{this.state.loan_amount} {this.state.user_data.currency ==="EGP"?"جنيه":this.state.user_data.currency } </p>
                <hr />
                <p className="contact_summary_field" id="monthly_paid"><span>القسط الشهري</span>{this.state.monthly_paid} {this.state.user_data.currency ==="EGP"?"جنيه":this.state.user_data.currency } </p>
                <hr />
                <p className="contact_summary_field" id="admin_fees"><span>مصاريف ادارية</span>{this.state.fees} {this.state.user_data.currency ==="EGP"?"جنيه":this.state.user_data.currency } </p>
            </div>}
     
            {this.state.error &&
                <div className="iframe_error">
                    {this.state.error_message}
                </div>
            }
            <button disabled={!this.state.submit_step_2} onClick={(e)=>this.installment_plan_review(e)}>{this.state.localeText.proceed}</button>
        </div>
    )

    renderStep3 = () => (
        <div className="contact_iframe_content text-center">
            <h1>{this.state.localeText.verification}</h1>
            <p>{this.state.localeText.verification_please_enter}<br/>{this.state.mobile_number}</p>
            <OtpInput 
                numInputs={4} 
                value={this.state.otp}
                onChange={(value) => this.handle_otp_change(value)} 
                isInputNum
                containerStyle="OtpInput"
                placeholder="•••••"
            />
            {this.state.otp_error &&
                <div className="alert alert-danger" id="otp_error">
                    {this.state.otp_error_message}
                </div>
            }
            {this.state.lang==="en"?       <div className="resend_otp">
                <p>
                    Didn’t receive code?
                    {this.state.resend?
                        <span>Send again in<span>{this.state.resend_counter}</span> sec.</span>
                    :
                        <span className="send_again" onClick={()=>this.resendOtp()}>Send again</span>
                    }
                </p>
            </div>:       <div className="resend_otp">
                <p>
                      لم تستلم الرمز ؟
                    {this.state.resend?
                        <span > ارسل مجددا في <span>{this.state.resend_counter}</span> ثانيه</span>
                    :
                        <span className="send_again" onClick={()=>this.resendOtp()}>&nbsp;ارسل مره اخرى&nbsp;</span>
                    }
                </p>
            </div>}
     
            {this.state.error &&
                <div className="iframe_error">
                    {this.state.error_message}
                </div>
            }
            <button disabled={!this.state.submit_step_4} id="confirm_otp" onClick={()=>this.confirmTrnx()}>{this.state.localeText.confirm}</button>
        </div>
    )

    // End UI ..........................................................................

    render() {
        return (
            <div className="iframe_page">
                <div className="iframe_container contact_container">
                    {(this.state.step !== 1 && this.state.status === null && !this.state.waiting && !this.state.public_error ) && 
                        <>
                            <span onClick={()=>this.handleBack()} className="back_btn"><img src={BackIcon} alt="Back" /> {this.state.localeText.back}</span>
                        </>
                    }
                    {(this.state.status === null && !this.state.waiting && !this.state.public_error ) && 
                        <>
                            <span onClick={()=>this.changeLanguage()} className="cancel_btn">{this.state.lang==="en"?"ع":"EN"}</span>
                        </>
                    }
                    {this.state.status === null &&
                        <div className="iframe_header">
                            <img src={Logo} alt="Contact"/>
                        </div>
                    }
                    {this.state.waiting ?
                        <Waiting height='350px' />
                    :
                        this.state.public_error ?
                            <div className="iframe_error public_error">
                                {this.state.public_error_message}
                            </div>
                        :
                            this.state.status == null ?
                                <>
                                    {this.state.step === 1 && this.renderStep1()}
                                    {this.state.step === 2 && this.renderStep2()}
                                    {this.state.step === 3 && this.renderStep3()}
                                    {this.state.step === 4 && this.renderStep4()}
                                </>
                            :
                                <Status
                                    status={this.state.status}
                                    status_message={this.state.status_message}
                                    gateway_name="Contact"
                                    redirection_url={this.state.redirection_url}
                                />
                    }
                    <div className="iframe_footer">
                        <span>Powered by</span>
                        <img src={paymobLogo} alt="Paymob" className="paymob" />
                    </div>
                </div>
            </div>
        )
    }
}
export default Contact;